import { Model } from 'components/discovery/utils/model.js'

export type BusinessHours = {
  name: string,
  day: string,
  time_from: string | null | undefined,
  time_to: string | null | undefined,
  text: string,
}

export type GeoLocation = {
  latitude: number | null,
  longitude: number | null,
}

export type Address = {
  street: string,
  street1: string,
  house_number: string | null,
  zipcode: string,
  city: string,
  country: string,
  geo_location: GeoLocation,
  subdivision: any,
  website: string,
}

export type Store = {
  id: number,
  name: string,
  email?: string | null,
  phone?: string | null,
  square_meters?: string | null,
  logo?: string | null,
  website_url?: string | null,
  address: Address,
  premium: boolean | null,
  bank?: string | null,
  business_hours: Array<BusinessHours>,
  coc?: string | null,
  description?: string | null,
  distance_in_km: number,
  distance_in_m: number,
  meta_description?: string | null,
  meta_title?: string | null,
  url_conditions?: string | null,
  vat?: string | null,
}

export type BusinessHoursInternal = {
  name: string,
  day: string,
  timeFrom: string | null | undefined,
  timeTo: string | null | undefined,
  text: string,
}

export type AddressInternal = {
  street: string,
  street1: string,
  houseNumber: string,
  zipcode: string,
  city: string,
  country: string,
  geoLocation: GeoLocation,
  subdivision: any,
  website: string,
}

export type InternalStore = {
  id: number,
  name: string,
  email?: string | null,
  phone?: string | null,
  squareMeters: string,
  logo: string,
  websiteUrl: string,
  address: AddressInternal,
  premium: boolean,
  bank: string,
  businessHours: Array<BusinessHoursInternal>,
  coc: string,
  description: string,
  distanceInKm: number,
  distanceInM: number,
  metaDescription: string,
  metaTitle: string,
  urlConditions: string,
  vat: string,
}


export class StoreModel extends Model<Store> implements Store {
  id = 0
  name = ''
  email = ''
  phone = ''
  square_meters = ''
  logo =  ''
  website_url = ''
  address = {
    street: '',
    street1: '',
    house_number: '',
    zipcode: '',
    city: '',
    country: '',
    geo_location: {
      latitude: null,
      longitude: null,
    },
    subdivision: '',
    website: '',
  }
  premium =  false
  bank = ''
  business_hours: Array<BusinessHours> = []
  coc = ''
  description = ''
  distance_in_km = 0
  distance_in_m =  0
  meta_description = ''
  meta_title = ''
  url_conditions = ''
  vat = ''

  parseToInternal = (): InternalStore => {
    return {
      id: this.id,
      name: this.name,
      email: this.email,
      phone: this.phone,
      squareMeters: this.square_meters,
      logo: this.logo,
      websiteUrl: this.website_url || this.address.website,
      address: {
        street: this.address.street,
        street1: this.address.street1,
        houseNumber: this.address.house_number,
        zipcode: this.address.zipcode,
        city: this.address.city,
        country: this.address.country,
        geoLocation: {
          latitude: this.address.geo_location.latitude,
          longitude: this.address.geo_location.longitude,
        },
        subdivision: this.address.subdivision,
        website: this.address.website,
      },
      premium: this.premium,
      bank: this.bank,
      businessHours: this.business_hours.map(element => ({
        name: element.name,
        day: element.day,
        timeFrom: element.time_from,
        timeTo: element.time_to,
        text: element.text,
      })),
      coc: this.coc,
      description: this.description,
      distanceInKm: this.distance_in_km,
      distanceInM: this.distance_in_m,
      metaDescription: this.meta_description,
      metaTitle: this.meta_title,
      urlConditions: this.url_conditions,
      vat: this.vat,
    }
  }
}

export type StoresResponse = {
  stores: Array<Store>
}
